import React from "react";

function CloneForDEX() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is a Decentralized Exchange?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  A Decentralized Exchange (DEX) is a cryptocurrency trading
                  platform that operates without a central authority or
                  intermediary, allowing users to trade directly with each other
                  (peer-to-peer) on the blockchain. Instead of relying on a
                  central entity to manage trades and hold assets, DEXs utilize
                  smart contracts – self-executing agreements written in code –
                  to automatically facilitate and record transactions.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="/contact-us">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default CloneForDEX;
